// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'animal-print';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinejoin='round'
    d='M11.31 11.125a2.656 2.656 0 0 0-5.313 0 2.125 2.125 0 0 0 0 4.25 2.97 2.97 0 0 0 1.338-.354 2.856 2.856 0 0 1 2.635 0 2.97 2.97 0 0 0 1.34.354 2.125 2.125 0 0 0 0-4.25zM1.215 8.469a1.594 1.594 0 1 0 3.188 0 1.594 1.594 0 0 0-3.188 0zm3.188-4.25a1.594 1.594 0 1 0 3.187 0 1.594 1.594 0 0 0-3.187 0zm5.312 0a1.594 1.594 0 1 0 3.188 0 1.594 1.594 0 0 0-3.188 0zm3.719 4.25a1.594 1.594 0 1 0 3.188 0 1.594 1.594 0 0 0-3.188 0z'
  />
);

export const viewBox = '0 0 18 18';
